import React, { Component } from 'react';
import { Row, Col, Card, Button, Select, Form, Divider } from 'antd';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';
const Option = Select.Option;

@withRouter
@inject('store')
@observer
export class CoinSpecificStratsSection extends Component {
    constructor(props) {
        super(props);

        this.state = {
            symbol: null,
            buy_sell: '',
            adca: '',
            art: ''
        };
    }

    handleAddEntry() {
        if (this.state.symbol === null) return;

        let config = { ...this.props.store.botStore.currentConfiguration.coin_configuration } || {};

        config[this.state.symbol] = {
            buy_sell: this.state.buy_sell,
            adca: this.state.adca,
            art: this.state.art
        };

        this.props.store.botStore.updateConfig({ coin_configuration: config });
        this.setState({ symbol: null, buy_sell: '', adca: '', art: '' });
    }

    removeEntry(symbol) {
        let config = { ...this.props.store.botStore.currentConfiguration.coin_configuration } || {};
        delete config[symbol];
        this.props.store.botStore.updateConfigValue('coin_configuration', config);
    }

    updateEntry(symbol, key, value) {
        let config = { ...this.props.store.botStore.currentConfiguration.coin_configuration } || {};
        let row = { ...config[symbol] };
        row[key] = value;
        config[symbol] = row;
        this.props.store.botStore.updateConfig({ coin_configuration: config });
    }

    render() {
        const baseCurrency = this.props.store.botStore.currentConfiguration.base_currency || 'BTC';

        const symbols = Object.keys(this.props.store.botStore.marketStore.market)
            .map(p => this.props.store.botStore.marketStore.market[p])
            .filter(t => t.symbol.indexOf(baseCurrency.toUpperCase()) >= 2);

        return (
            <Card bordered={false} title="Coin Specific Strategies">
                <Row gutter={24}>
                    <Col md={4}>
                        <Form.Item label="Symbol">
                            <Select
                                showSearch
                                style={{ width: '100%' }}
                                value={this.state.symbol}
                                onChange={val => this.setState({ symbol: val })}
                            >
                                {symbols.map(symbol => (
                                    <Option key={symbol.name} value={symbol.name}>
                                        {symbol.symbol}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col md={6}>
                        <Form.Item label="Buy & Sell">
                            <Select
                                showSearch
                                style={{ width: '100%' }}
                                value={this.state.buy_sell}
                                onChange={val => this.setState({ buy_sell: val })}
                                filterOption={(input, option) =>
                                    option.props.children
                                        .toLowerCase()
                                        .indexOf(input.toLowerCase()) >= 0
                                }
                                optionFilterProp="name"
                            >
                                <Option value="">None</Option>
                                {this.props.store.strategyStore.buySell
                                    .slice()
                                    .sort((a, b) => {
                                        if (a.name < b.name) return -1;
                                        if (a.name > b.name) return 1;
                                        return 0;
                                    })
                                    .map(s => {
                                        return (
                                            <Option value={s.id} key={s.id}>
                                                {s.name}
                                            </Option>
                                        );
                                    })}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col md={6}>
                        <Form.Item label="Auto Dollar Cost Averaging">
                            <Select
                                showSearch
                                style={{ width: '100%' }}
                                value={this.state.adca}
                                onChange={val => this.setState({ adca: val })}
                                filterOption={(input, option) =>
                                    option.props.children
                                        .toLowerCase()
                                        .indexOf(input.toLowerCase()) >= 0
                                }
                                optionFilterProp="name"
                            >
                                <Option value="">None</Option>
                                {this.props.store.strategyStore.adca
                                    .slice()
                                    .sort((a, b) => {
                                        if (a.name < b.name) return -1;
                                        if (a.name > b.name) return 1;
                                        return 0;
                                    })
                                    .map(s => {
                                        return (
                                            <Option value={s.id} key={s.id}>
                                                {s.name}
                                            </Option>
                                        );
                                    })}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col md={6}>
                        <Form.Item label="Auto Reverse Trading">
                            <Select
                                showSearch
                                style={{ width: '100%' }}
                                value={this.state.art}
                                onChange={val => this.setState({ art: val })}
                                filterOption={(input, option) =>
                                    option.props.children
                                        .toLowerCase()
                                        .indexOf(input.toLowerCase()) >= 0
                                }
                                optionFilterProp="name"
                            >
                                <Option value="">None</Option>
                                {this.props.store.strategyStore.art
                                    .slice()
                                    .sort((a, b) => {
                                        if (a.name < b.name) return -1;
                                        if (a.name > b.name) return 1;
                                        return 0;
                                    })
                                    .map(s => {
                                        return (
                                            <Option value={s.id} key={s.id}>
                                                {s.name}
                                            </Option>
                                        );
                                    })}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col md={2}>
                        <Form.Item>
                            <Button
                                onClick={this.handleAddEntry.bind(this)}
                                style={{ marginTop: 41 }}
                                type={'primary'}
                            >
                                Add
                            </Button>
                        </Form.Item>
                    </Col>
                </Row>

                <Divider />

                {Object.keys(
                    this.props.store.botStore.currentConfiguration.coin_configuration || {}
                ).map(symbol => {
                    const row = this.props.store.botStore.currentConfiguration.coin_configuration[
                        symbol
                    ];
                    return (
                        <Row key={symbol} gutter={24} style={{ marginBottom: 5 }}>
                            <Col md={4}>
                                <div style={{ marginTop: 7 }}>
                                    <b>{symbol}</b>
                                </div>
                            </Col>

                            <Col md={6}>
                                <Select
                                    showSearch
                                    style={{ width: '100%' }}
                                    value={row.buy_sell}
                                    onChange={val => this.updateEntry(symbol, 'buy_sell', val)}
                                >
                                    <Option value="">None</Option>
                                    {this.props.store.strategyStore.buySell
                                        .slice()
                                        .sort((a, b) => {
                                            if (a.name < b.name) return -1;
                                            if (a.name > b.name) return 1;
                                            return 0;
                                        })
                                        .map(s => {
                                            return (
                                                <Option value={s.id} key={s.id}>
                                                    {s.name}
                                                </Option>
                                            );
                                        })}
                                </Select>
                            </Col>

                            <Col md={6}>
                                <Select
                                    showSearch
                                    style={{ width: '100%' }}
                                    value={row.adca}
                                    onChange={val => this.updateEntry(symbol, 'adca', val)}
                                >
                                    <Option value="">None</Option>
                                    {this.props.store.strategyStore.adca
                                        .slice()
                                        .sort((a, b) => {
                                            if (a.name < b.name) return -1;
                                            if (a.name > b.name) return 1;
                                            return 0;
                                        })
                                        .map(s => {
                                            return (
                                                <Option value={s.id} key={s.id}>
                                                    {s.name}
                                                </Option>
                                            );
                                        })}
                                </Select>
                            </Col>

                            <Col md={6}>
                                <Select
                                    showSearch
                                    style={{ width: '100%' }}
                                    value={row.art}
                                    onChange={val => this.updateEntry(symbol, 'art', val)}
                                >
                                    <Option value="">None</Option>
                                    {this.props.store.strategyStore.art
                                        .slice()
                                        .sort((a, b) => {
                                            if (a.name < b.name) return -1;
                                            if (a.name > b.name) return 1;
                                            return 0;
                                        })
                                        .map(s => {
                                            return (
                                                <Option value={s.id} key={s.id}>
                                                    {s.name}
                                                </Option>
                                            );
                                        })}
                                </Select>
                            </Col>

                            <Col md={2}>
                                <Button
                                    onClick={this.removeEntry.bind(this, symbol)}
                                    shape="circle"
                                    type="danger"
                                    icon="close-circle"
                                />
                            </Col>
                        </Row>
                    );
                })}
            </Card>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/Bot/SettingsView/CoinSpecificStratsSection.js